import React from 'react';
import Typography from '@mui/material/Typography';
import styles from './FeatureWrap.module.scss';
import {AttentionSeeker, Fade, Hinge} from 'react-awesome-reveal';

interface FeaturesProps {
    title: React.ReactNode;
    content: React.ReactNode;
    img: string;
    imgSize: number;
}

const Features: React.FC<FeaturesProps> = ({title, content, img, imgSize}) => {
    return (
        <div className={`${styles.feature}`}>
            <div className={styles.horizontal}>
                <AttentionSeeker effect={"pulse"} style={{
                    marginTop: 'auto',
                    marginBottom: 'auto'
                }}>
                    <img src={img} alt={typeof title === 'string' ? title : 'Feature image'} width={imgSize}
                         height={imgSize}
                         style={{
                             width: imgSize + 'px',
                             height: imgSize + 'px',
                             maxWidth: imgSize + 'px',
                             maxHeight: imgSize + 'px',
                             marginTop: 'auto',
                             marginBottom: ' auto'
                         }}/>
                </AttentionSeeker>
                <div className={styles.title}>
                    {typeof title === 'string' ? (
                        <Typography variant="h4" component="div">
                            {title}
                        </Typography>
                    ) : (
                        title
                    )}
                </div>
            </div>
            <div className={styles.content}>
                {typeof content === 'string' ? (
                    <p>
                        {content}
                    </p>
                ) : (
                    content
                )}
            </div>
        </div>
    );
};

export default Features;